import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Kan jag få serveringstillstånd utan fast lokal?";
const SHORT_ANSWER = "Ja, via cateringtillstånd eller tillfälliga tillstånd. Stadigvarande tillstånd för 'roterande verksamhet' kräver alltid lämplig lokal vid varje tillfälle.";

export const Route = createFileRoute("/fraga/far-jag-ha-tillstand-utan-fysisk-lokal")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Kan jag få serveringstillstånd utan fast lokal" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Cateringtillstånd förutsätter att lokalen för varje uppdrag är lämplig och anmäls i förväg till kommunen. Food trucks regleras särskilt – läs vidare nedan."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/serveringstillstand-food-truck-guide", label: "Food truck och catering" }}
      related={[{"to": "/fraga/food-truck-vad-galler", "label": "Vad gäller för food truck och alkoholservering?"}, {"to": "/fraga/hur-mycket-kostar-tillfalligt-tillstand", "label": "Vad kostar ett tillfälligt serveringstillstånd?"}, {"to": "/fraga/far-jag-foreningens-arsfest-utan-tillstand", "label": "Behöver föreningen tillstånd för årsfest med vin?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Kan jag få serveringstillstånd utan fast lokal?" },
      { name: "description", content: "Ja, via cateringtillstånd eller tillfälliga tillstånd. Stadigvarande tillstånd för 'roterande verksamhet' kräver alltid lämplig lokal vid varje tillfälle." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-ha-tillstand-utan-fysisk-lokal" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-ha-tillstand-utan-fysisk-lokal" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-ha-tillstand-utan-fysisk-lokal",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Kan jag få serveringstillstånd utan fast lokal", url: "https://alkoholprovet.se/fraga/far-jag-ha-tillstand-utan-fysisk-lokal" },
      ]),
    ],
  }),
});
